// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__SVIas","link__underline":"link_link__underline__0M8Cn"};